import { AnalyticsConsentDialogState } from './analytics-consent-dialog.state';

/**
 * Initialer State für den Analytics-Consent-Dialog.
 */
export const analyticsConsentDialogStateInitial: AnalyticsConsentDialogState = {
  isOpen: false,
};
